module.exports = {"name":"entity","menu":{"label":"Intenções","route":"/pontos-de-vista","parent":"menuEngagement","weight":4}}


//////////////////
// WEBPACK FOOTER
// ./_source/javascripts/modules/entity/config.json
// module id = 388
// module chunks = 0